// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/animate.css/animate.min.css
// module id = 794
// module chunks = 1